var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearningNeedsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53676 21.5874L6.63007 7.58803C6.63173 7.32533 6.68512 7.06554 6.78721 6.82349C6.88929 6.58143 7.03806 6.36186 7.22502 6.17732C7.41197 5.99277 7.63346 5.84686 7.87681 5.74793C8.12017 5.64899 8.38063 5.59897 8.64333 5.60072L20.6436 5.68187C21.174 5.68548 21.6812 5.89964 22.0537 6.27722C22.4262 6.65481 22.6335 7.1649 22.6299 7.6953L22.5366 21.6947C22.5349 21.9574 22.4815 22.2172 22.3794 22.4592C22.2774 22.7013 22.1286 22.9208 21.9416 23.1054C21.7547 23.2899 21.5332 23.4358 21.2898 23.5348C21.0465 23.6337 20.786 23.6837 20.5233 23.682L8.52308 23.6008C7.99269 23.5972 7.48545 23.3831 7.11295 23.0055C6.74045 22.6279 6.53318 22.1178 6.53676 21.5874Z",
    stroke: "#CB8B65",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6167 9.61363L18.617 9.66669M10.5896 13.6134L18.5901 13.6674M10.5634 17.613L15.5634 17.6471",
    stroke: "#CB8B65",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.746887 4.81445) rotate(-9.61804)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningNeedsIcon);
export default __webpack_public_path__ + "static/media/LearningNeedsIcon.79a4fcd421cbd10c7dfdf07c42429ac3.svg";
export { ForwardRef as ReactComponent };